<script setup lang="ts">
const { t } =  useI18n({
  useScope: "local",
});

defineProps({
  dataTrackingId: {
    type: String as PropType<string | string[]>,
    default: '',
  },
  dataPage: {
    type: String,
    default: '',
  },
});

const { trackRegisterImageGallery } = useGoogleTagManager();

function register() {
  trackRegisterImageGallery();
}
</script>

<template>
  <div class="conversion-overlay">
    <span class="--text">{{ t('register')}}</span>
    <tw-button-register
      @click:register="register"
      :login-type="'column'"
      :data-page="dataPage"
      :data-tracking-id="dataTrackingId"
    />
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/tw-variables.scss";
@import "@/assets/styles/tw-mixins.scss";

.conversion-overlay {
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  align-items: center;
  justify-content: center;
  z-index: 1;

  .tw-button {
    padding: calc(0.26em* 2.5) calc(0.26em* 8);
    font-weight: bold;
    text-transform: uppercase;
    @include tw-color-set($white, $primary, $primary);
    &:hover {
      @include tw-color-set($white, #d47d00, #d47d00);
    }
  }

  .--text {
    padding: 0 1rem;
    color: #fff;
    font-size: 1.2rem;
    text-align: center;
  }
  .--footer {
    margin-top: 0.5rem;
    width: 100%;
    font-size: 0.9rem;
    color: $white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

:deep(.register-button-login) {
  color: $white;
}
</style>
<i18n lang="json">
{
  "de": {
    "register": "Registriere dich, um alle Fotos zu sehen"
  },
  "en": {
    "register": "Register to see all photos"
  }
}
</i18n>

